const ProcessEndpoints = {
  migrateFiles: {
    method: 'POST',
    url: () => `/process/migrate-files`,
  },
} as const;

export default ProcessEndpoints;
